import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExportJobs, ExportJobRequest, ExportJob } from './export';
import { BaseService } from '@eview/core/base/base-service';
import { ListPostOptions } from '../post/post';

@Injectable({
  providedIn: 'root'
})
export class ExportService extends BaseService {
  readonly uris = {
    exportPosts: `export-posts`,
    exportUsers: `users/export/csv`,
    createJob: `exports/jobs`,
    readJob: 'exports/jobs/:id',
    listJobs: `exports/jobs`
  };

  exportPosts(request: ListPostOptions & { columns?: string }): Observable<any> {
    return this.http.get<any>(this.getUrl(this.uris.exportPosts), {
      params: super.getParamsFromObject(request)
    });
  }

  exportUsers(): Observable<any> {
    return this.http.get<any>(this.getUrl(this.uris.exportUsers));
  }

  createJob(request: ExportJobRequest): Observable<ExportJob> {
    return this.http.post<ExportJob>(this.getUrl(this.uris.createJob), request);
  }

  readJob(id: number): Observable<ExportJob> {
    return this.http.get<ExportJob>(
      this.getUrl(this.uris.readJob).replace(':id', id.toString())
    );
  }

  listJobs(): Observable<ExportJobs> {
    return this.http.get<ExportJobs>(this.getUrl(this.uris.listJobs));
  }
}
